// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608052329/js/" + chunkId + "." + {"44":"1edd7497","225":"2d70e722","481":"40b5539f","486":"a6de7e2b","770":"025e9e33"}[chunkId] + ".0.990645383111386.chunk.js";
};